import { type ComponentStyleConfig } from '@chakra-ui/react'
import { merge } from 'lodash'

import { inputs } from '../inputs'

export const Select: ComponentStyleConfig = merge({}, inputs, {
  baseStyle: {
    icon: {
      color: 'primary.darkGreen.100',
    },
  },
  variants: {
    light: {
      icon: {
        color: '#ffffff',
      },
      field: {
        '> option, > optgroup': {
          backgroundColor: 'primary.darkGreen.100',
        },
      },
    },
  },
} as ComponentStyleConfig)
